module.exports = __webpack_public_path__ + "img/imgHeader_01.057c7a21.png";